// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ticket-chat {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
  height: 560px; /* hauteur prédéfinie */
  max-height: 560px;
  position: relative;
}

.ticket-chat__list {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow-y: auto;
  padding-right: 0.4rem;
  overscroll-behavior: contain;
}

.ticket-chat__empty {
  margin: 0;
  padding: 1.5rem 1rem;
  border: 1px dashed #FDBA74;
  background: #FFF8F2;
  color: #C2410C;
  border-radius: 0.75rem;
  font-size: 0.9rem;
}

.ticket-chat__item {
  display: flex;
  flex-direction: column;
  max-width: 78%;
}

.ticket-chat__item--self {
  align-self: flex-end;
  text-align: right;
}

.ticket-chat__item--other {
  align-self: flex-start;
  text-align: left;
}

.ticket-chat__bubble {
  background-color: var(--orange-100, #FFF4E6);
  color: var(--orange-800, #7C2D12);
  padding: 0.85rem 1.1rem;
  border-radius: 1.05rem;
  border-bottom-left-radius: 0.3rem;
  font-size: 1.15rem;
  line-height: 1.45;
  word-break: break-word;
  box-shadow: 0 2px 4px rgba(0,0,0,0.08);
}

.ticket-chat__item--self .ticket-chat__bubble {
  background-color: var(--orange-500, #F97316);
  color: #fff;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 0.3rem;
}


.ticket-chat__input:focus {
  outline: none;
  border-color: #FB923C;
  box-shadow: 0 0 0 3px rgba(251,146,60,0.35);
}

.ticket-chat__item--self .ticket-chat__meta {
  justify-content: flex-end;
}

.ticket-chat__author {
  font-weight: 500;
}

.ticket-chat__form {
  display: flex;
  gap: 0.6rem;
  position: sticky;
  bottom: 0;
  background: #fff;
  padding: 0.6rem 0 0.2rem;
  flex-shrink: 0;
  border-top: 1px solid #f3f3f3;
}

.ticket-chat__input {
  flex: 1 1;
  padding: 0.8rem 0.95rem;
  border: 1px solid var(--neutral-200, #e5e7eb);
  border-radius: 0.65rem;
  font-size: 1.05rem;
  background: #fff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.ticket-chat__input:focus {
  outline: none;
  border-color: #FB923C;
  box-shadow: 0 0 0 3px rgba(251,146,60,0.35);
}


.ticket-chat__input:disabled {
  background-color: var(--neutral-100, #f3f4f6);
  cursor: not-allowed;
}

.ticket-chat__send {
  padding: 0.75rem 1.35rem;
  border: none;
  border-radius: 0.65rem;
  background: linear-gradient(135deg, #FB923C, #F97316);
  color: #fff;
  font-weight: 600;
  font-size: 1.05rem;
  cursor: pointer;
  transition: filter 0.2s ease, transform 0.15s ease;
  box-shadow: 0 4px 12px -2px rgba(249,115,22,0.35);
}

.ticket-chat__send:disabled {
  background: #FCD9B6;
  color: #8C8C8C;
  box-shadow: none;
  cursor: not-allowed;
}

.ticket-chat__send:not(:disabled):hover {
  filter: brightness(1.05);
  transform: translateY(-2px);
}

.ticket-chat__error {
  margin: 0;
  font-size: 0.9rem;
  color: var(--danger-500, #ef4444);
}

@media (max-width: 800px) {
  .ticket-chat {
    height: 480px;
    max-height: 480px;
  }
  .ticket-chat__bubble {
    font-size: 1.05rem;
  }
}

@media (max-width: 600px) {
  .ticket-chat {
    height: 420px;
    max-height: 420px;
  }
  .ticket-chat__form {
    padding: 0.5rem 0 0.15rem;
  }
  .ticket-chat__bubble {
    font-size: 0.95rem;
    padding: 0.7rem 0.85rem;
  }
  .ticket-chat__send,
  .ticket-chat__input {
    font-size: 0.9rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/composants/Ticket/TicketChat/TicketChat.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,aAAa,EAAE,uBAAuB;EACtC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,iCAAiC;EACjC,uBAAuB;EACvB,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,4CAA4C;EAC5C,WAAW;EACX,+BAA+B;EAC/B,kCAAkC;AACpC;;;AAGA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,6CAA6C;EAC7C,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,wDAAwD;AAC1D;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;;AAGA;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,sBAAsB;EACtB,qDAAqD;EACrD,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kDAAkD;EAClD,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;EACA;;IAEE,iBAAiB;EACnB;AACF","sourcesContent":[".ticket-chat {\n  display: flex;\n  flex-direction: column;\n  gap: 0.9rem;\n  height: 560px; /* hauteur prédéfinie */\n  max-height: 560px;\n  position: relative;\n}\n\n.ticket-chat__list {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  overflow-y: auto;\n  padding-right: 0.4rem;\n  overscroll-behavior: contain;\n}\n\n.ticket-chat__empty {\n  margin: 0;\n  padding: 1.5rem 1rem;\n  border: 1px dashed #FDBA74;\n  background: #FFF8F2;\n  color: #C2410C;\n  border-radius: 0.75rem;\n  font-size: 0.9rem;\n}\n\n.ticket-chat__item {\n  display: flex;\n  flex-direction: column;\n  max-width: 78%;\n}\n\n.ticket-chat__item--self {\n  align-self: flex-end;\n  text-align: right;\n}\n\n.ticket-chat__item--other {\n  align-self: flex-start;\n  text-align: left;\n}\n\n.ticket-chat__bubble {\n  background-color: var(--orange-100, #FFF4E6);\n  color: var(--orange-800, #7C2D12);\n  padding: 0.85rem 1.1rem;\n  border-radius: 1.05rem;\n  border-bottom-left-radius: 0.3rem;\n  font-size: 1.15rem;\n  line-height: 1.45;\n  word-break: break-word;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.08);\n}\n\n.ticket-chat__item--self .ticket-chat__bubble {\n  background-color: var(--orange-500, #F97316);\n  color: #fff;\n  border-bottom-left-radius: 1rem;\n  border-bottom-right-radius: 0.3rem;\n}\n\n\n.ticket-chat__input:focus {\n  outline: none;\n  border-color: #FB923C;\n  box-shadow: 0 0 0 3px rgba(251,146,60,0.35);\n}\n\n.ticket-chat__item--self .ticket-chat__meta {\n  justify-content: flex-end;\n}\n\n.ticket-chat__author {\n  font-weight: 500;\n}\n\n.ticket-chat__form {\n  display: flex;\n  gap: 0.6rem;\n  position: sticky;\n  bottom: 0;\n  background: #fff;\n  padding: 0.6rem 0 0.2rem;\n  flex-shrink: 0;\n  border-top: 1px solid #f3f3f3;\n}\n\n.ticket-chat__input {\n  flex: 1;\n  padding: 0.8rem 0.95rem;\n  border: 1px solid var(--neutral-200, #e5e7eb);\n  border-radius: 0.65rem;\n  font-size: 1.05rem;\n  background: #fff;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n.ticket-chat__input:focus {\n  outline: none;\n  border-color: #FB923C;\n  box-shadow: 0 0 0 3px rgba(251,146,60,0.35);\n}\n\n\n.ticket-chat__input:disabled {\n  background-color: var(--neutral-100, #f3f4f6);\n  cursor: not-allowed;\n}\n\n.ticket-chat__send {\n  padding: 0.75rem 1.35rem;\n  border: none;\n  border-radius: 0.65rem;\n  background: linear-gradient(135deg, #FB923C, #F97316);\n  color: #fff;\n  font-weight: 600;\n  font-size: 1.05rem;\n  cursor: pointer;\n  transition: filter 0.2s ease, transform 0.15s ease;\n  box-shadow: 0 4px 12px -2px rgba(249,115,22,0.35);\n}\n\n.ticket-chat__send:disabled {\n  background: #FCD9B6;\n  color: #8C8C8C;\n  box-shadow: none;\n  cursor: not-allowed;\n}\n\n.ticket-chat__send:not(:disabled):hover {\n  filter: brightness(1.05);\n  transform: translateY(-2px);\n}\n\n.ticket-chat__error {\n  margin: 0;\n  font-size: 0.9rem;\n  color: var(--danger-500, #ef4444);\n}\n\n@media (max-width: 800px) {\n  .ticket-chat {\n    height: 480px;\n    max-height: 480px;\n  }\n  .ticket-chat__bubble {\n    font-size: 1.05rem;\n  }\n}\n\n@media (max-width: 600px) {\n  .ticket-chat {\n    height: 420px;\n    max-height: 420px;\n  }\n  .ticket-chat__form {\n    padding: 0.5rem 0 0.15rem;\n  }\n  .ticket-chat__bubble {\n    font-size: 0.95rem;\n    padding: 0.7rem 0.85rem;\n  }\n  .ticket-chat__send,\n  .ticket-chat__input {\n    font-size: 0.9rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
